<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <item-list
          :dialog-visible="chooseCustomerDialogVisible"
          :headers="customersChooseHeaders"
          :item-list="customerChooseList"
          item-key="customerId"
          title="Выберите клиента"
          @close="chooseCustomerDialogVisible = false"
          @getItem="onSetCustomer"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              :footer-props="datatable_footer"
              :headers="headers"
              :items="campaigns"
              :options.sync="table_options"
              :server-items-length="total"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <autocomplete
                          ref="autocomplete"

                          :get-result-value="getResultValue"
                          :search="search"
                          @submit="onSubmit"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        sm="3"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onOpenFilter"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        v-if="role === 1"
                        class="d-flex justify-sm-end"
                        cols="12"
                        md="5"
                        sm="5"
                      >
                        <v-menu
                          allow-overflow
                          class="overflow-auto"
                          max-height="clamp(300px,300px, 400px)"
                          max-width="350px"
                          transition="slide-x-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-1 pa-1"
                              color="primary"
                              v-bind="attrs"
                              @click="onCreateItemByAdmin"
                              v-on="on"
                            >
                              <v-icon class="ml-3">
                                mdi-plus
                              </v-icon>
                              <span class="md-1 mx-3">Добавить</span>
                            </v-btn>
                          </template>
                          <!--                          <v-list>-->
                          <!--                            <v-subheader class="blue lighten-4">-->
                          <!--                              Выбор клиента-->
                          <!--                            </v-subheader>-->
                          <!--                            <v-list-item-->
                          <!--                              v-for="customer in customers"-->
                          <!--                              :key="customer.value"-->
                          <!--                              link-->
                          <!--                              @click="onSetCustomer(customer.value)"-->
                          <!--                            >-->
                          <!--                              <v-list-item-title v-text="customer.text" />-->
                          <!--                            </v-list-item>-->
                          <!--                          </v-list>-->
                        </v-menu>
                      </v-col>
                      <v-col
                        v-if="role === 2"
                        class="d-flex justify-sm-end"
                        cols="12"
                        md="5"
                        sm="5"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-1 pa-1"
                              color="primary"
                              v-bind="attrs"
                              @click="onCreateItem"
                              v-on="on"
                            >
                              <v-icon class="ml-3">
                                mdi-plus
                              </v-icon>
                              <span class="md-1 mx-3">Добавить</span>
                            </v-btn>
                          </template>
                          <span>Создать новую Программу лояльности</span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        class="d-flex justify-sm-end"
                        cols="12"
                        md="2"
                        sm="4"
                      >
                        <v-btn
                          class="ma-1 pa-1"
                          color="secondary"
                          outlined
                          @click="downloadReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          class="icon-table"
                          medium
                          @click="onOpenHeader"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row>
                      <div>
                        <v-chip
                          v-for="(filter, index) in filterStuff"
                          v-show="filter.fieldTitle !== '' "
                          :key="'i' + index"
                          close
                          @click:close="onClearFilter(filter)"
                        >
                          <span>{{ filter.fieldTitle }}</span>
                        </v-chip>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <task-menu
                  @delete="deleteItem(item)"
                  @edit="editItem(item)"
                />
              </template>
              <template v-slot:item.rules="{ item }">
                <v-icon>
                  mdi-notebook-outline
                </v-icon>
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="item.status.color"
                >
                  {{ item.status.text }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-headers="dialogHeaders"
          :dialog-visible="headerDialogVisible"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CampaignModel, CampaignHeadersModel, CampaignTitlesModel, campaignCsv } from "../../models/campaign.model"
import TaskMenu from "../../shared/components/task-menu/TaskMenu"
import WebApi from "../../shared/modules/web_api"
import {
    downloadCsvFile,
    getCsvFile,
    getObjectsForSearching,
    getSearchedObjects
} from "@/views/loyalty/shared/modules/utilities"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog"
import { clearFilter, FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import ItemList from "@/views/loyalty/shared/components/item-list/ItemList.vue"
import { CampaignService } from "@/views/loyalty/shared/services/campaign-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"
import { TransactionTitlesModel } from "@/views/loyalty/models/transaction.model"
import CampignTitlesModel from "core-js/client/core"

export default {
    name: "CampaignList",
    components: { ItemList, Autocomplete, FilterDialog, HeaderDialog, TaskMenu },
    data: () => ({
        campaigns: [],
        campaignService: null,
        customerId: null,
        customers: [],
        customersChooseHeaders: [
            // {
            //     text: "Программа лояльности",
            //     value: "campaignId"
            // },
            {
                text: "Наименование",
                value: "name"
            },
            {
                text: "Выбрать",
                value: "actions",
                sortable: false
            }
        ],
        customerChooseList: [],
        datatable_footer: {
            itemsPerPageText: 'Показывать по',
            pageText: 'из',
            itemsPerPageAllText: 'Все',
        },
        dialogHeaders: [],
        chooseCustomerDialogVisible: false,
        filterDialogVisible: false,
        filterLabel: 'campaign.filter',
        filterStuff: [],
        headerDialogVisible: false,
        headers: [
            {
                text: 'Действия',
                value: 'actions',
                sortable: false
            }
        ],
        headerService: null,
        role: 0,
      searchStuff: null,
        table_options: {},
        total: 0,
        user: null
    }),
    watch: {
        table_options: {
            async handler () {
                console.log(this.table_options)
                const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
                this.campaigns = await this.getItems()
            },
            deep: true,
        },
    },
    beforeMount () {
        const that = this
        localStorage.removeItem(this.filterLabel)
        this.campaignService = new CampaignService()
        this.headerService = new HeaderService(CampaignHeadersModel)
        this.webApi = new WebApi(this.$store).readError("Не удалось прочитать данные")
            .deleteSuccess("Программы лояльности удалена!")
            .deleteError("Произошла ошибка при удалении Программы лояльности!")
        this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/campaign/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
            .then(function (data) {
                console.log('header data', data)
                that.dialogHeaders = that.headerService.get_header(data)
                console.log('that.dialogHeaders', that.dialogHeaders)
                // that.headers = that.headerService.get_header_list(data)
                that.headers = [...that.headers, ...CampaignHeadersModel]
                console.log('that.headers', that.headers)
            })
        this.role = +this.$route.params.role
        this.user = this.role === 1 ? 'admin' : 'client'
        // this.setStatusFilter()
        this.fillFilterStuff()
        this.fillSearchStuff()
        // this.onSetFilter()
    },
    async mounted () {
        this.campaigns = await this.getItems()
        console.log('this.campaigns', this.campaigns)
    },
    methods: {
        async deleteItem (item) {
            const response = await this.campaignService.deleteCampaign(item.campaignId)
            console.log('response', response)
            if (response) {
                CampaignModel.clearItems()
                this.campaigns = await this.getItems()
            }
        },
        downloadReport () {
            console.log("campaign", this.campaigns)
            let csv = campaignCsv
            csv += getCsvFile(this.campaigns)
            console.log("csv", csv)
            downloadCsvFile("CampaignReport", csv)
        },
        fillFilterStuff () {
            this.filterStuff = new FilterStuff()
            CampaignTitlesModel.forEach(item => this.filterStuff.add(new FilterItem().fieldKey(item.value).fieldName(item.text).fieldValue("").fieldType(item.filterType).fieldValues(item.filterValues).fieldMoney().fieldDate().fieldTitle("").value))
            this.filterStuff = this.filterStuff.items
            console.log('filterStuff', this.filterStuff)
            return this.filterStuff
        },
      fillSearchStuff () {
        this.searchStuff = Object.assign({}, SearchStuffModel)
        this.searchStuff.fieldNames = CampaignTitlesModel.map(m => Object.fromEntries(Object.entries(m).filter(([key, value]) => {
          if (key === 'value' || key === 'filterType') { return value }
        })))
        console.log('this.searchStuff:', this.searchStuff)
      },
        editItem (item) {
            item.status = item.status.value
            console.log("editItem item=", item)
            localStock.setItem('campaign', item)
            this.$router.push(`/${this.user}/campaign/edit/${this.role}/${item.campaignId}/${item.customerId}`)
        },
        async getItems () {
            let campaigns = null
            const filterStuff = this.filterStuff.filter(f => f.fieldValue.toString().length > 0 || Object.keys(f.fieldDate).length > 0 || Object.keys(f.fieldMoney).length > 0)
                .map(fs => Object.fromEntries(Object.entries(fs).filter(([key]) => [
                    'fieldValue', 'fieldDate', 'fieldMoney', 'fieldType', 'fieldKey'].includes(key)
                )))
            console.log('getItems filterStuff:', filterStuff)
            if (this.role === 1) {
                campaigns = await this.campaignService.getAllCampaigns(this.table_options.page, this.table_options.itemsPerPage, filterStuff, this.searchStuff)
                console.log('campaigns:', campaigns)
                this.total = campaigns.count
            }
            if (this.role === 2) {
                campaigns = await this.campaignService.getCampaignsByCustomerId(this.$store.state.client ? this.$store.state.client.id : "0", this.table_options.page, this.table_options.itemsPerPage, filterStuff, this.searchStuff)
                console.log('campaigns:', campaigns)
                this.total = campaigns.count
            }
            return campaigns.items.map(item => this.setItems(item))
        },
        getResultValue (result) {
            return result.searched
        },
        onClearFilter (filter) {
            console.log('filter', filter)
            const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
            // const newFilter = attrFilter.filter(f => { if (f.fieldValue === filter.fieldValue) { f.fieldValue = ""; return true } else { return true } })
            const newFilter = clearFilter(attrFilter, filter)
            console.log('newFilter', newFilter)
            localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
            this.onSetFilter()
        },
        onCloseFilter () {
            const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
            console.log('const filterStuff', filterStuff)
            this.filterStuff = filterStuff || this.fillFilterStuff()
            console.log('onCloseFilter this.filterStuff', this.filterStuff)
            this.filterDialogVisible = false
        },
        onCloseHeader () {
            this.headerDialogVisible = false
        },
        onCreateItem () {
            const campaign = new CampaignModel()
            campaign.status = campaign.status.value
            localStock.setItem('campaign', campaign)
            this.$router.push(`/client/campaign/create/0/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
        },
        // todo: change logic
        async onCreateItemByAdmin () {
            const justpayClientService = new JustpayClient()
            this.customers = await justpayClientService.getClients()
            console.log('this.customers', this.customers)
            const campaign = new CampaignModel()
            campaign.status = campaign.status.value
            localStock.setItem('campaign', campaign)
            this.customerChooseList = this.customers.map(customer => {
                return { customerId: customer.value, name: customer.text }
            })
            this.chooseCustomerDialogVisible = true
            // this.$router.push(`/client/campaign/create/0/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
        },
        onOpenFilter () {
            this.filterDialogVisible = true
        },
        async onOpenHeader () {
            this.headerDialogVisible = true
            const data = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/campaign/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
            this.dialogHeaders = this.headerService.get_header(data)
        },
        onSetCustomer (item) {
            console.log('customerId:', item[0].customerId)
            this.$router.push(`/admin/campaign/create/0/${item[0].customerId}`)
        },
        async onSetFilter () {
            this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || this.fillFilterStuff()
            this.filterDialogVisible = false
            console.log('this.filterStuff', this.filterStuff)
            this.campaigns = await this.getItems()
            console.log('this.campaigns', this.campaigns)
        },
        onSetHeader (value) {
            console.log('onSetHeader', value)
            this.dialogHeaders = value
            this.headerDialogVisible = false
            const headers = this.headerService.set_header("campaign", this.$store.state.client ? this.$store.state.client.id : "0", value)
            console.log('headers', headers)
            this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/header/`, headers)
            // this.headers = this.headerService.get_header_list(headers)
            this.headers = [...this.headers, ...CampaignHeadersModel]
        },
        async onSubmit (result) {
            const searching = result.searched ? result.searched : result
            if (searching.length !== 0) {
              this.searchStuff.fieldValue = searching
                this.campaigns = await this.getItems()
            } else {
              this.searchStuff.fieldValue = ''
              await this.onSetFilter()
            }
        },
        search (input) {
            console.log('search', input)
            if (input.length < 1) {
                return []
            }
            const arr = getSearchedObjects(this.campaigns, input)
            console.log('arr', arr)
            return arr
        },
        setStatusFilter () {
            localStorage.setItem(this.filterLabel, JSON.stringify([{ fieldDate: {}, fieldKey: "status", fieldMoney: {}, fieldType: "list_boolean", fieldValue: true, fieldName: "Статус", fieldTitle: "Статус: Активна", fieldGroupValues: [{ text: "Активна", value: true }, { text: "Неактивна", value: false }] }]))
        },
        setItems (data) {
            return Reflect.construct(CampaignModel, [data])
        }
    }
}
</script>

<style scoped></style>
